import { useTranslation } from '@mint-lib/i18n';
import { Folder } from '@mint-lib/icons';
import {
  FeaturedIcon,
  Skeleton,
  typographyVariants,
} from '@mint-lib/tw-components';

import type { FileNode, FolderNode } from '../../../../types/fileSystem.js';
import { MovePickerFile, MovePickerFolder } from './MovePickerItem.jsx';

type MovePickerListingProps = {
  isLoading: boolean;
  folders: FolderNode[];
  files: FileNode[];
  privateBucketId?: string;
  privateBucketLabel: string;
  movingIds: Set<string>;
  onOpenFolder?: (folder: FolderNode) => void;
};

const MovePickerListing = ({
  isLoading,
  folders,
  files,
  privateBucketId,
  privateBucketLabel,
  movingIds,
  onOpenFolder,
}: MovePickerListingProps) => {
  const { t } = useTranslation('@mint-lib/ai-chat');

  if (isLoading) {
    return (
      <div className="flex flex-col gap-2" data-testid="move-picker-skeleton">
        {Array.from({ length: 5 }, (_, index) => (
          <Skeleton key={index} variant="rounded" className="h-10" />
        ))}
      </div>
    );
  }

  if (!folders.length && !files.length) {
    return (
      <div className="flex h-80 w-full flex-col items-center justify-center gap-4">
        <FeaturedIcon icon={<Folder />} />
        <p className={typographyVariants({ variant: 'h4' })}>
          {t('This folder is empty')}
        </p>
      </div>
    );
  }

  return (
    <div className="flex flex-col gap-2">
      {folders.map((folder) => (
        <MovePickerFolder
          key={folder.id}
          folder={folder}
          label={folder.id === privateBucketId ? privateBucketLabel : undefined}
          disabled={movingIds.has(folder.id)}
          onOpen={onOpenFolder}
        />
      ))}
      {files.map((file) => (
        <MovePickerFile key={file.id} file={file} />
      ))}
    </div>
  );
};

export { MovePickerListing };
